<template>
  <FileUpload
      auto
      chooseLabel=" "
      :show-upload-button="false"
      :show-cancel-button="false"
      :file-limit="parseInt(fileLimit)"
      :accept="accept ?? (acceptArray ? acceptArray.map(type => `.${type}`).join(','):null)"
      :invalid-file-limit-message="`Limite máximo de arquivos é de ${fileLimit}`"
      :pt="{
      chooseButton: {
        class: [
          'bg-transparent dark:bg-slate-700/50 border-theme p-2',
          this.focusFocusClass
        ]
      },
      root: {
        class: [
          'dark:border-white/20 hover:border-theme/50 border rounded-md',
          transitionClass
        ]
      },
      chooseIcon: {
        class: [
          'm-0 text-black/90 dark:text-white/80 hover:text-theme text-sm',
          transitionClass
        ]
      },
      chooseButtonLabel: {
        class: 'hidden'
      },
      buttonbar: {
        class: 'rounded-t-md rounded-b-none dark:bg-slate-800 border-0 p-4'
      },
      content: {
        class: 'rounded-t-none rounded-b-md dark:bg-slate-700 border-0'
      },
      file: {
        class: 'text-default dark:text-white'
      },
    }"
      @before-send="handleUpdate"
      @upload="uploaded"

  >
    <template #empty>
      <p class="text-center text-sm text-default/60 dark:text-white/60 italic">
        {{ emptyMessage }}
      </p>
    </template>
  </FileUpload>
</template>


<script>

import FileUpload from 'primevue/fileupload';

export default {
  name: "RpmFileInput",
  components: {
    FileUpload
  },
  props: {
    emptyMessage: {
      type: String,
      default: "Arraste e solte arquivos para enviar"
    },
    focusFocusClass: {
      type: String,
      default: ""
    },
    placeHolderClass: {
      type: String,
      default: ""
    },
    transitionClass: {
      type: String,
      default: ""
    },
    disabledClass: {
      type: String,
      default: ""
    },
    paddingClass: {
      type: String,
      default: ""
    },
    borderClass: {
      type: String,
      default: ""
    },
    focusClass: {
      type: String,
      default: ""
    },
    panelClass: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
    accept: {
      type: [String, Array, Object],
      default: null
    },
    acceptArray: {
      type: Array,
      default: null
    },
    fileLimit: {
      type: [String, Number],
      default: null
    },
  },
  methods: {
    handleUpdate(event) {
      event.xhr.open("POST", this.$attrs.url);
      event.xhr.setRequestHeader("Authorization", 'Bearer ' + sessionStorage.getItem('token'));
      event.xhr.setRequestHeader("Accept", 'application/json');
      event.xhr.send(event.formData)
    },
    uploaded(event) {
      let jsonResponse = JSON.parse(event.xhr.response)
      this.$emit('uploaded', jsonResponse.data)
    }
  },
};

</script>
